<div class="month-status" [class.month-status--locked]="state.isSettled()">
	@if (state.isSettled()) {
		<mat-icon class="month-status__icon"><i class="fa-solid fa-lock"></i></mat-icon>
		<div class="month-status__text">
			<strong>Rozliczony — edycja zablokowana</strong>
			<span>
				{{ state.settledAt() | date: 'd MMM yyyy, HH:mm' }}
				@if (state.settledBy()) {
					· {{ state.settledBy() }}
				}
			</span>
		</div>
		<button
			mat-stroked-button
			color="warn"
			type="button"
			class="month-status__unlock"
			[disabled]="state.settleLoading()"
			[matTooltip]="unlockTooltip"
			(click)="state.unsettleMonth()"
		>
			@if (state.settleLoading()) {
				<mat-spinner diameter="14"></mat-spinner>
			} @else {
				<mat-icon><i class="fa-solid fa-lock-open"></i></mat-icon>
			}
			Odblokuj edycję
		</button>
	} @else {
		<mat-icon class="month-status__icon"><i class="fa-solid fa-lock-open"></i></mat-icon>
		<div class="month-status__text">
			<strong>Nierozliczony — edycja odblokowana</strong>
		</div>
	}
	@if (state.settleError()) {
		<span class="month-status__error">{{ state.settleError() }}</span>
	}
</div>
